(function () {
    'use strict';

    angular.module('swif.ui')
        .controller('ModalController', ModalController)
        .directive('modalActionsPreset', modalActionsPreset)
        .directive('swifModalPanelInfo', swifModalPanelInfo);


    function ModalController($scope, $uibModalInstance, $q, modalParams, swif) {
        'ngInject';
        console.log('init ModalController');
        $scope.modalParams = modalParams;
        $scope.title = modalParams.title || modalParams.model.name;
        $scope.model = modalParams.model;
        $scope.templateUrl = modalParams.templateUrl;
        $scope.isModal = true;
        $scope.smsFeature = swif.settings.app.features.sms;
        $scope.action = modalParams.action;
        $scope.isSmsModal = $scope.action ? $scope.action.isSmsModal : false;
        $scope.preValidate = modalParams.preValidate;
        $scope.options = modalParams.options;
        $scope.presetAction = {value: {}};
        $scope.userAgent = navigator.userAgent;
        $scope.today = new Date();
        $scope.localStorage = window.localStorage;
        if ($scope.action) {
            if ($scope.action.btn !== undefined) {
                if ($scope.action.btn['class'] === undefined) {
                    $scope.action.btn['class'] = 'btn-primary';
                }
            } else {
                $scope.action.btn = {'class': 'btn-primary'};
            }
        }
        $scope.loading = {loading: false};
        $scope.disabled = false || (!swif.settings.app.features.sms && $scope.isSmsModal);
        var onError = function () {
            swif.message.loading($scope.loading, 'ko');
            $scope.disabled = false;
        };
        $scope.ok = function () {
            $scope.disabled = true;
            if ($scope.action) {
                swif.message.loading($scope.loading);
                var prevalidate_data = {action: $scope.action, model: $scope.model};
                swif.action.preValidate($scope.preValidate, prevalidate_data)
                .then(function (preValidated) {
                    if (preValidated) {
                        if (prevalidate_data.action.http) {
                            var callback;
                            if (modalParams.options) {
                                callback = modalParams.options.callback;
                            }
                            if (prevalidate_data.model
                                    && !prevalidate_data.model.args
                                    && prevalidate_data.action.id == 'regroup') {
                                prevalidate_data.model.args = [prevalidate_data.model.id, prevalidate_data.model.regroup_ask_id[0]];
                            } 
                            if (Array.isArray(prevalidate_data.model._multiple) && prevalidate_data.model._multiple.length > 0 ) {
                                // If multiple task to create (because of many agent assigned)
                                // we change the workflow to firstly create every secondary task one by one
                                // then the last task, because we don't have an async context here, 
                                // cwe recursively ast task creation
                                function createTask(t) {
                                    swif.action._ajaxAction(
                                        modalParams.contentType,
                                        prevalidate_data.action,
                                        t
                                    ).then(function() {
                                        if (prevalidate_data.model._multiple.length > 0) {
                                            createTask(prevalidate_data.model._multiple.pop())
                                        } else {
                                            swif.action._ajaxAction(
                                                modalParams.contentType,
                                                prevalidate_data.action,
                                                prevalidate_data.model,
                                                callback
                                            ).then(function () {
                                                swif.message.loading($scope.loading, 'ok');
                                                $uibModalInstance.close(prevalidate_data.model);
                                            }, onError);
                                        }
                                    })
                                }
                                createTask(prevalidate_data.model._multiple.pop())
                            } else {
                                swif.action._ajaxAction(
                                    modalParams.contentType,
                                    prevalidate_data.action,
                                    prevalidate_data.model,
                                    callback
                                ).then(function () {
                                    swif.message.loading($scope.loading, 'ok');
                                    $uibModalInstance.close(prevalidate_data.model);
                                }, onError);
                            }
                        } else {
                            swif.message.loading($scope.loading, 'ok');
                            if (modalParams.options) {
                                if (modalParams.options.callback !== undefined) {
                                    modalParams.options.callback(null, prevalidate_data);
                                }
                            }
                            $uibModalInstance.close($scope.model);
                        }

                        // if an action-preset is filled (from modal-action-preset directive)
                        // dispatch this action when preValidate has processed
                        if ($scope.presetAction.value.id) {
                            var defer = true;
                            // for new model (in 'add' action, for example),
                            // recompute 'actions' before dispatching the action
                            if (!prevalidate_data.model.actions || _.isEmpty(prevalidate_data.model.actions)) {
                                defer = swif.data.get(
                                    prevalidate_data.model._type || modalParams.contentType,
                                    prevalidate_data.model.id,
                                    {fields: ['actions']}
                                )
                                .then(function (data) {
                                    prevalidate_data.model.actions = data.actions;
                                });
                            }
                            $q.when(defer).then(function () {
                                swif.action.dispatch(
                                    prevalidate_data.model._type,
                                    $scope.presetAction.value,
                                    prevalidate_data.model,
                                    modalParams.options
                                );
                            });
                        }
                    } else {
                        $scope.disabled = false;
                        swif.message.loading($scope.loading, 'ko');
                        console.log('action aborted by prevalidate');
                        //$uibModalInstance.dismiss('cancel');
                    }
                }, onError);
            } else {
                $uibModalInstance.close(modalParams);
            }
        };
        $scope.cancel = function () {
            var callback = modalParams.options ? modalParams.options.dismissCallback : null;
            if (callback) {
                callback(modalParams);
            }
            $uibModalInstance.dismiss('cancel');
        };
    }

    function modalActionsPreset(swifStateService, actionService, settingsService) {
        'ngInject';
        var ret = {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                mode: '@?',
                model: '=',
                category: '@?',
                defaultActionId: '@?'
            },
            link: function (scope, element,attr, ngModel) {
                scope.proxy = {presetAction: {}, contentType: {}};
                if (scope.model._type) {
                    scope.proxy.contentType = settingsService.app.contentTypes[scope.model._type];
                }
                scope.initialized = false;
                scope.computeStateAndActions = function () {
                    scope.state = swifStateService.getStateInfo(scope.model.state, scope.model);
                    scope.actions = actionService.getActions(
                        scope.model._type,
                        scope.category || 'workflow',
                        scope.model
                    );
                    if (scope.defaultActionId && !scope.initialized) {
                        scope.proxy.presetAction = _.find(scope.actions, function (elt) {
                            return elt.id === scope.defaultActionId;
                        }) || {};
                        scope.initialized = true;
                    }
                };
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    if (vv) {
                        scope.proxy.presetAction = vv;
                    }
                };
                scope.sync = function () {
                    ngModel.$setViewValue(scope.proxy.presetAction);
                };
                scope.$watchGroup(['proxy.presetAction', 'defaultActionId'], function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        scope.sync();
                    }
                });
                scope.$watch('model', function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        scope.computeStateAndActions();
                    }
                }, true);
            },
            templateUrl: 'partials/ui/modal-actions-preset.html'
        };
        return ret;
    }

    function swifModalPanelInfo(swif) {
        'ngInject';
        var directive = {
            restrict: 'E',
            require: 'ngModel',
            replace:true,
            scope: {},
            link: function (scope, element, attr, ngModel) {
                ngModel.$render = function () {
                    scope.proxy = ngModel.$viewValue;
                };
                element.on('click', function (event) {
                    event.stopPropagation();
                    var params = {
                        scope: scope,
                        templateUrl: 'partials/ui/swif_panel_proxy.html',
                        model: scope.proxy,
                        title: 'Summary'
                    };
                    swif.modal.open(params);
                });
            },
            template: '<i class="fa fa-fw fa-info-circle btn-link"></i>'
        };
        return directive;
    }

})();
